import React, {memo} from 'react'
import cx from 'classnames'

/* Utils */
import {generateExperiments} from '../../../../modules/analytics/analyticsUtils'
import {getShipmentType} from '../../../../modules/product/productDesktopUtils'
import DataSet from '../../../../utils/DataSet'
import {yieldToMain} from '../../../../utils/performance'

/* Constants */
import {MODAL_IDS} from '../../../../modules/modal/modalConstants'
import {DAVINCI_EVENT_NAMES} from '../../../../modules/analytics/davinci/davinciConstants'

/* Actions */
import {actionCreators as modalActionCreators} from '../../../../redux/actions/modalActions'

/* Styles */
import s from './campaigns.scss'

const Campaigns = memo(
  ({
    dispatch,
    campaigns,
    sku,
    merchantId,
    categories,
    shipmentInformation,
    product_status,
    merchantName,
    categoryName,
    categoryId,
    price,
    isInStock,
    isPreOrder,
    listingId,
    productId,
    pageTypeForDavinci
  }) => {
    const handleClick = async() => {
      let data = {
        category_hierarchy: categories?.map((item) => ({
          id: item?.categoryId || '',
          name: item?.categoryName || '',
        })),
        merchant: {
          id: merchantId,
          name: merchantName,
        },
        category: {
          id: categoryId,
          name: categoryName,
        },
        products: [
          {
            product_id: productId,
            price: price?.toString() || '',
            sku: sku,
            product_status,
            shipping_type: getShipmentType({
              isInStock,
              isPreOrder,
              shipmentInformation,
            }),
            listing_id: listingId,
            position: 1,
          },
        ],
      };

      window?.hepsiBus?.track('ViewCampaignsClick', data, generateExperiments())
      await yieldToMain()
      dispatch(
        modalActionCreators.openModal(MODAL_IDS.CAMPAIGN)
      )
    }

    const handleCampaignOnClick = async(item) => {
      await yieldToMain()
      window?.hepsiBus?.track(DAVINCI_EVENT_NAMES.LINK_CLICK, {
        location: item?.campaignLink,
        page_type: pageTypeForDavinci,
        page_value: sku,
        placement: 'CampaignTab',
        site_type: 'desktop'
      })
    }

    if (!campaigns) {
      return null
    }

    return (
      <div className={cx(s.root)} data-test-id={'campaigns'}>
        {
          campaigns?.length > 0 ? (
            <div
              className={s.campaignsContainer}
              data-hbus={DataSet.createCampaignsViewDataForDavinci({
                sku,
                merchantName,
                merchantId,
                listingId,
                price,
                campaigns,
                productId
              })}>
              <div className={s.titleContainer}>
                <div className={s.title}>{'Kampanyalar'}</div>
                {
                  campaigns?.length > 3 &&
                  <div className={s.seeAllButton} onClick={() => handleClick()}>
                    {'Tümünü gör'}
                    <div className={s.angleRightIcon}></div>
                  </div>
                }
              </div>
              <div>
                {
                  campaigns?.slice?.(0, 3).map((item, index) => {
                    const CampaignComponent = item?.campaignLink ? 'a':'div'
                    const CampaignProps = item?.campaignLink ? {href: item?.campaignLink, target:'_blank'} : {}
                    return (
                      <CampaignComponent className={cx(s.content)} key={index} {...CampaignProps} onClick={() => handleCampaignOnClick(item)}>
                        <div
                          aria-hidden
                          className={cx(s.icon, {
                            [s.icon1]: item?.campaignType === 1,
                            [s.icon2]: item?.campaignType !== 1,
                          })}></div>
                        <div className={s.text}>{item?.campaignName}</div>
                      </CampaignComponent>
                    )
                  })
                }
              </div>
            </div>
          ) : null
        }
      </div>
    )
  }
)

export default Campaigns
